/**
 * Core
 */
import React from "react";

/**
 * Styles
 */
import "./Indicator.scss";

const Indicator = ({
  iconIndicator,
  className,
  textLabel,
  isActive,
  onClick,
}) => {
  return (
    <div className="indicator__wrap">
      <div
        onClick={onClick}
        className={isActive ? `${className} active` : className}
      >
        <img src={iconIndicator} alt={textLabel} />
      </div>
      <span>{textLabel}</span>
    </div>
  );
};

export default Indicator;
